module.exports = __webpack_public_path__ + "img/warrior_f.99304475.png";